// We name this InMessageFile instead of File so that we don't mix up
// with existing javascript File class
export class InMessageFile {
  // Used when the backend returns messages to a GET
  mime_type: string;
  file_name: string;

  // Added by the frontend
  url?: string;

  // Used when posting a new file
  constructor(public uuid?: string) {}
}
